/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{toPt as r}from"../../../core/screenUtils.js";function e(e){return r(e)}export{e as castSizeFromStringOrNumber};
